import { render, staticRenderFns } from "./organization-unit-seal-panel.vue?vue&type=template&id=0fb02a3e&scoped=true&"
import script from "./organization-unit-seal-panel.vue?vue&type=script&lang=js&"
export * from "./organization-unit-seal-panel.vue?vue&type=script&lang=js&"
import style0 from "./organization-unit-seal-panel.vue?vue&type=style&index=0&id=0fb02a3e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb02a3e",
  null
  
)

export default component.exports